/* Sommaire automatique - Litiere Tranquille
   Parse les H2 du contenu d'article, injecte des IDs, genere le sommaire.
   Gere accents FR, apostrophes, doublons (slugs incrementes). */
(function () {
  'use strict';

  function slugify(text) {
    return (text || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/['\u2019\u2018]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function uniqueSlug(base, used) {
    if (!base) base = 'section';
    var slug = base, i = 2;
    while (used.has(slug)) {
      slug = base + '-' + i;
      i++;
    }
    used.add(slug);
    return slug;
  }

  function initToc() {
    var tocContainer = document.getElementById('article-toc');
    if (!tocContainer) return;

    var scope = document.querySelector('.section-article-content-blocks') || document;
    var headings = scope.querySelectorAll('h2');
    var usedIds = new Set();
    var items = [];

    headings.forEach(function (h2) {
      if (h2.closest('.faq-section') || h2.closest('.cta-final') || h2.closest('.article-summary')) return;

      var id = h2.id;
      if (!id) {
        var base = slugify(h2.textContent);
        id = uniqueSlug(base, usedIds);
        h2.id = id;
      } else {
        usedIds.add(id);
      }

      items.push({ id: id, text: h2.textContent.trim() });
    });

    if (!items.length) {
      tocContainer.classList.add('toc--empty');
      return;
    }

    var ol = document.createElement('ol');
    items.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + item.id;
      a.textContent = item.text;
      a.setAttribute('data-toc-link', '');
      li.appendChild(a);
      ol.appendChild(li);
    });

    var list = tocContainer.querySelector('[data-toc-list]');
    if (list) {
      list.innerHTML = '';
      list.appendChild(ol);
    } else {
      tocContainer.appendChild(ol);
    }

    tocContainer.classList.remove('toc--empty');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToc);
  } else {
    initToc();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#article-toc')) {
      initToc();
    }
  });
})();
